import { useCallback, useEffect, useState } from 'react';

import { nanoid } from 'nanoid';
import { arrayOf, number, oneOfType, shape, string } from 'prop-types';
import { getErrors } from 'utils/old-ui-commons/input-label-error';

import { Box, FieldError, SelectFilter } from '@olist/united';

const SelectInput = ({ input, meta, options, ...props }) => {
  const [key, setKey] = useState(nanoid(8));

  const hasErrorAndTouched = meta.error && meta.touched;
  const hasSubmitError = !meta.dirtySinceLastSubmit && meta.submitError;
  const errors = meta.error || meta.submitError;

  const initialSelection = useCallback(() => {
    if (input.value) {
      return options.find((option) => option.value === input.value) ?? [];
    }
    return [];
  }, [input.value, options]);

  useEffect(() => setKey(nanoid(8)), [initialSelection]);

  return (
    <>
      <SelectFilter
        key={key}
        id={input.name}
        name={input.name}
        error={getErrors(meta)}
        onOptionChange={({ value }) => input.onChange(value)}
        options={options}
        initialValue={initialSelection()}
        {...input}
        {...props}
      />
      {(hasErrorAndTouched || hasSubmitError) && (
        <Box mt={2}>
          <FieldError messages={errors} />
        </Box>
      )}
    </>
  );
};

SelectInput.propTypes = {
  meta: shape({}).isRequired,
  input: shape({}).isRequired,
  options: arrayOf(shape({ label: string, value: oneOfType([string, number]) })).isRequired,
};

export default SelectInput;
